import { chineseLevels } from "@/content/chinese";
import { englishLevels } from "@/content/english";
import { focusSocialLevels } from "@/content/focus-social";
import { habitsLevels } from "@/content/habits";
import { MATH_LEVELS } from "@/content/math";
import type { Domain, LevelDefinition } from "@/domain";

export const LEVELS_BY_DOMAIN: Readonly<
  Record<Domain, readonly LevelDefinition[]>
> = {
  chinese: chineseLevels,
  math: MATH_LEVELS,
  english: englishLevels,
  habits: habitsLevels,
  "focus-social": focusSocialLevels
};
